import { FC, useRef } from 'react'
import classNames from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

import { teamData } from 'resources'
import { useResponsive, useVersion } from 'hooks'
import { SectionLayout } from 'components'

import styles from './Team.module.scss'
import TeamCard from './TeamCard'

interface TeamProps {
  addToRefs?: (el: HTMLDivElement) => void
}

const Team: FC<TeamProps> = ({ addToRefs }) => {
  const swiperRef = useRef()
  const { version } = useVersion()
  const { isTabletLarge, isMobileM } = useResponsive()

  const activeVersionData = teamData[version as keyof typeof teamData]
  const renderTeamList = activeVersionData.map(data => <TeamCard key={data.id} data={data} />)

  const renderSliderTeamList = activeVersionData.map(data => (
    <SwiperSlide key={data.id}>
      <TeamCard key={data.id} data={data} />
    </SwiperSlide>
  ))

  const pagination = {
    clickable: true,
    renderBullet: function (_: number, className: string) {
      return `<span class="${className}"> </span>`
    },
  }

  return (
    <SectionLayout id='TEAM' addToRefs={addToRefs} className={styles.container}>
      <div className='container'>
        <h2 className={styles.title}>Team</h2>
        {!isTabletLarge ? (
          <div className={styles.wrapper}>{renderTeamList}</div>
        ) : (
          <div className={classNames(styles.feedback, 'teamSlider')}>
            <Swiper
              loop
              initialSlide={1}
              onBeforeInit={(swiper: any) => {
                swiperRef.current = swiper as any
              }}
              pagination={pagination}
              modules={[Autoplay, Pagination, Navigation]}
              spaceBetween={28}
              slidesPerView={isMobileM ? 1 : 2}
            >
              <>{renderSliderTeamList}</>
            </Swiper>
          </div>
        )}
      </div>
    </SectionLayout>
  )
}

export default Team
